import { useState, useCallback } from "react";
import AdminPayoutServices from "@/services/adminPayoutServices";
import { BatchWithdrawalItem, EligibleWithdrawal } from "@/types/adminPayout";
import { showSuccess, showError } from "@/utils/toast";

const useBatchProcessPayout = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const processBatch = useCallback(
    async (eligibleWithdrawals: EligibleWithdrawal[]) => {
      if (eligibleWithdrawals.length === 0) {
        showError("No eligible withdrawals to process");
        return false;
      }

      setIsProcessing(true);

      try {
        const withdrawals: BatchWithdrawalItem[] = eligibleWithdrawals.map(
          (item) => ({
            userId: item.userId,
            amount: item.amount,
          })
        );

        await AdminPayoutServices.processBatch(withdrawals);
        showSuccess(`Successfully processed ${withdrawals.length} payouts`);
        return true;
      } catch (error) {
        console.error("Failed to process batch payouts:", error);
        showError("Failed to process payouts. Please try again.");
        return false;
      } finally {
        setIsProcessing(false);
      }
    },
    []
  );

  return {
    isProcessing,
    processBatch,
  };
};

export default useBatchProcessPayout;
